import { Befehl34FormData, Befehl34FormSchema } from './schema'
import { Befehl34 } from '../../../models'
import {
  Befehl34DataDto,
  BefehlAuftrag_34_10Dto,
  Feld_34_11Dto,
  Feld_34_12Dto,
  Feld_34_13Dto
} from '../../../dtos/befehl-34-dto'
import {
  findAuftragByKennung,
  createKmhField,
  createZugmeldestelleField
} from '../converter-utils'

export const convertModelToBefehl34FormData = (
  befehl?: Befehl34
): Befehl34FormData => {
  const formData = Befehl34FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag3410 = findAuftragByKennung(
    befehl.auftraege,
    '34.10'
  ) as BefehlAuftrag_34_10Dto

  const feld3411 = auftrag3410?.felder?.find(
    (feld) => feld.kennung === '34.11'
  ) as Feld_34_11Dto

  const feld3412 = auftrag3410?.felder?.find(
    (feld) => feld.kennung === '34.12'
  ) as Feld_34_12Dto

  const feld3413 = auftrag3410?.felder?.find(
    (feld) => feld.kennung === '34.13'
  ) as Feld_34_13Dto

  if (auftrag3410) {
    if (feld3411?.werte?.kmh) {
      formData.auftrag_34_10.field_34_11_kmh = feld3411.werte.kmh
    }

    if (feld3412?.werte?.zugmeldestelle) {
      formData.auftrag_34_10.field_34_12_von = {
        art: feld3412.werte.zugmeldestelle.art || '',
        name: feld3412.werte.zugmeldestelle.name || ''
      }
    }

    if (feld3413?.werte?.zugmeldestelle) {
      formData.auftrag_34_10.field_34_13_bis = {
        art: feld3413.werte.zugmeldestelle.art || '',
        name: feld3413.werte.zugmeldestelle.name || ''
      }
    }
  }

  return formData
}

export const convertBefehl34FormDataToModel = (
  formData: Befehl34FormData,
  frontendId: string
): Befehl34 => {
  const auftraege: Befehl34DataDto = []

  if (formData.auftrag_34_10?.enabled) {
    auftraege.push({
      kennung: '34.10',
      felder: [
        createKmhField('34.11', formData.auftrag_34_10?.field_34_11_kmh),
        createZugmeldestelleField(
          '34.12',
          formData.auftrag_34_10?.field_34_12_von?.art,
          formData.auftrag_34_10?.field_34_12_von?.name
        ),
        createZugmeldestelleField(
          '34.13',
          formData.auftrag_34_10?.field_34_13_bis?.art,
          formData.auftrag_34_10?.field_34_13_bis?.name
        )
      ]
    } as BefehlAuftrag_34_10Dto)
  }

  return {
    kennung: '34',
    frontendId,
    auftraege
  }
}
